import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useAuth0 } from '@auth0/auth0-react';

const NonAuthedRoute = ({ children }) => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { user: auth0User } = useAuth0();

  //prevent user from going to login page if already logged in
  if (pathname === '/signin' && user) {
    return <Navigate to='/' replace />;
  }
  if (pathname === '/login' && user) {
    return <Navigate to='/' replace />;
  }
  return children;
};

export default NonAuthedRoute;
